import { ColDef, ICellRendererParams } from "ag-grid-community";
import { MoneyCellRenderer } from "../column-def-cell-renderers/money/MoneyCellRenderer";

export const resourceTotalSpendColumnDef: ColDef = {
  field: "resource.all_time_spent",
  headerName: "Total Spend",
  hide: true,
  cellRenderer: ({ data }: ICellRendererParams) => {
    const resource = data?.resource;

    if (!resource) {
      return null;
    }

    return <MoneyCellRenderer money={resource.all_time_spent} />;
  },
};
